<script setup lang="ts">
import { computed } from 'vue';

import HgGoldPartnerBadge from '@/assets/images/agent-badges/hg-gold-partner.png';
import HgSilverPartnerBadge from '@/assets/images/agent-badges/hg-silver-partner.png';
import Is24GoldPartnerBadge from '@/assets/images/agent-badges/is24-gold-partner.png';
import Is24SilverPartnerBadge from '@/assets/images/agent-badges/is24-silver-partner.png';
import { isPlatformIs24 } from '@/helpers/Platform/platform';
import type { PackageTier } from '@/types/agentProfile';

interface PartnerBadge {
  alt: string;
  src: string;
}

defineOptions({
  name: 'AgentPackageTierBadge',
});

const props = withDefaults(
  defineProps<{
    packageTier?: PackageTier | null;
  }>(),
  { packageTier: null },
);

const badge = computed<PartnerBadge | null>(() => {
  const badges: Partial<Record<NonNullable<PackageTier>, PartnerBadge>> = isPlatformIs24()
    ? {
        RE_GOLD: {
          alt: 'Gold Partner',
          src: Is24GoldPartnerBadge,
        },
        RE_SILVER: {
          alt: 'Silver Partner',
          src: Is24SilverPartnerBadge,
        },
      }
    : {
        RE_GOLD: {
          alt: 'Gold Partner',
          src: HgGoldPartnerBadge,
        },
        RE_SILVER: {
          alt: 'Silver Partner',
          src: HgSilverPartnerBadge,
        },
      };

  return badges[props.packageTier as NonNullable<PackageTier>] || null;
});
</script>

<template>
  <img
    v-if="badge"
    :class="$style.badge"
    :src="badge.src"
    :alt="badge.alt"
    data-test="agent-package-tier-badge"
  />
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.badge {
  display: block;
  width: $space-400;
  height: $space-400;

  @media (min-width: $viewport-md-min) {
    width: $space-500; /* 80px per Figma Agent Card v2 */
    height: $space-500;
  }
}
</style>
